export default {
  home: {
    sections: {
      trendingToday: "Tendencias de hoy",
      offers: "Ofertas",
      partners: "Socios",
      cheatsheets: "Cheatsheets",
      predictionMarkets: "Mercados de predicción",
      advancedTools: "Herramientas avanzadas",
      parlays: "Parlays",
      upcomingGames: "Próximos partidos",
    },
    offers: {
      types: {
        FANTASY_FREE_PICK: "Selecciones diarias",
        BOOST: "Impulsos",
        SPORTSBOOK_SIGNUP: "Casa de apuestas",
        FANTASY_SIGNUP: "Fantasy",
        PREDICTION_SIGNUP: "Predicciones",
        SWEEPSTAKES_SIGNUP: "Sorteos",
        CASINO_SIGNUP: "Casino",
        PARTNER: "Socios",
      },
    },
    offseason: {
      eyebrow: "Fuera de temporada",
      body: "¡Nos vemos pronto para la nueva temporada!",
    },
    seasonChampion: {
      description: "{{team}} son los {{championship}}.",
      descriptionWithArticle: "Los {{team}} son los {{championship}}.",
      descriptions: {
        default: "Campeones de {{league}}",
        superbowl: "Campeones del Super Bowl",
        stanleyCup: "Campeones de la Stanley Cup",
        premierLeague: "Campeones de la Premier League",
        worldSeries: "Campeones de la Serie Mundial",
        european: "Campeones de Europa",
        europaLeague: "Campeones de la Europa League",
        ncaaBasketball: "Campeones de baloncesto NCAA",
        ncaaFootball: "Campeones de fútbol americano NCAA",
      },
    },
    noGamesToday: "No hay partidos hoy en {{league}}.",
    currentlyInOffseason: "Actualmente fuera de temporada.",
    featured: {
      gameOfDay: "Partido del día",
      gameOfWeek: "Partido de la semana",
      parlayTrends: "Tendencias de parlays",
      cheatsheets: "Cheatsheets",
      unlockRewardTitle: "Desbloquea tu recompensa",
      unlockRewardSubtitle: "Obtén acceso premium para ver más.",
      unlockRewardBody: "Accede a más tendencias, herramientas e información.",
    },
    cards: {
      placeItOn: "Apuesta en",
      advancedToolsCta: "Únete a Linemate+",
      premiumBlurb: "Desbloquea la experiencia completa. Analiza cada tendencia en profundidad.",
    },
    empty: {
      trend: "No hay tendencias disponibles. Vuelve más tarde.",
      cheatsheet: "No hay guías rápidas disponibles. Vuelve más tarde.",
      offer: "No hay ofertas disponibles. Vuelve más tarde.",
    },
    cheatsheets: {
      recentForm: "Forma reciente",
      versusOpponent: "Contra este rival",
      alternateLines: "Líneas alternativas",
      firstQuarter: "Primer cuarto",
      firstHalf: "Primera mitad",
      homeAwayGames: "Local/Visitante",
      teamForm: "Forma del equipo",
      undersOnly: "Solo unders",
    },
    tools: {
      props: "Props",
      markets: "Mercados",
      cheatsheets: "Cheatsheets",
      generateParlay: "Creador de combinadas",
      lineups: "Alineaciones",
      injuries: "Lesiones",
      rank: "Ranking",
      weather: "Clima",
      pitchers: "Lanzadores",
      stats: "Estadísticas",
      standings: "Clasificación",
    },
    generateParlay: {
      parlayType: {
        subtitle: "Usa la forma reciente, el historial de enfrentamientos o el rendimiento en casa y fuera.",
        recentFormDescription: "Rendimiento en los últimos 20 partidos",
        versusOpponentDescription: "Últimos 20 partidos contra este rival",
        homeAwaySplitsDescription: "Últimos 20 partidos en casa o fuera",
      },
      legs: {
        title: "¿Cuántas selecciones quieres?",
        subtitle: "Elige el tamaño de la combinada que quieres generar",
        label: "{{count}} selecciones",
      },
      participants: {
        title: "¿A quién quieres incluir?",
        subtitle: "Elige los equipos o jugadores que quieres incluir en tu combinada",
        searchPlayer: "Buscar un jugador",
        searchTeam: "Buscar un equipo",
        allPlayers: "Todos los jugadores",
        allTeams: "Todos los equipos",
      },
      result: {name: "Combinada", title: "Tu combinada"},
      empty: {
        title: "No se encontró ninguna combinada",
        subtitle: "Prueba a cambiar tus selecciones para generar una combinada.",
      },
      actions: {goHome: "Volver al inicio", share: "Compartir combinada"},
      loader: {
        ready: "Combinada lista",
        accessibilityLabel: "Generando tu combinada",
        values: {
          legs: "{{count}} selecciones...",
          allGames: "Todos los partidos...",
          selectedGames: "{{count}} partidos...",
          allPlayers: "Todos los jugadores...",
          allTeams: "Todos los equipos...",
          selectedParticipants: "{{count}} participantes...",
          selectedBetTypes: "{{count}} tipos de apuesta...",
          selectedSportsbooks: "{{count}} casas de apuesta...",
          building: "Creando tu combinada...",
        },
      },
    },
    predictionMarkets: {
      hubTitle: "Centro de mercados de predicción",
      values: {
        points: "{{count}} pts",
        trades: "{{count}} operaciones",
      },
      analysis: {
        title: "Análisis de mercado",
        allExchanges: "Todas las bolsas",
        perExchange: "Por bolsa",
        chips: {
          all: "Todo",
          oneDay: "1 día",
          oneWeek: "1 semana",
        },
        rows: {
          volume: "Volumen",
          movement: "Movimiento",
          marketSplit: "Diferencia de mercado",
          largestTrade: "Operación más grande",
          activity: "Actividad",
        },
      },
      cards: {
        mostVolume: {
          title: "Mayor volumen",
          description: "Mercados con más dinero negociado",
        },
        largestTrades: {
          title: "Operaciones más grandes",
          description: "Mercados con las mayores operaciones individuales",
        },
        biggestMovers: {
          title: "Mayores movimientos",
          description: "Mercados con los mayores cambios de probabilidad",
        },
        marketsSplit: {
          title: "Diferencia de mercados",
          description: "Mercados con las mayores diferencias entre plataformas",
        },
        mostActivity: {
          title: "Mayor actividad",
          description: "Mercados con el mayor número de operaciones",
        },
      },
      previews: {
        superBowlWinner: "Ganador del Super Bowl",
        nbaChampions: "Campeones de la NBA",
        worldSeriesWinner: "Ganador de la Serie Mundial",
        easternConference: "Conferencia Este",
        westernConference: "Conferencia Oeste",
        nfcWinner: "Ganador de la NFC",
        afcChampions: "Campeones de la AFC",
        alPennant: "Banderín de la Liga Americana",
        stanleyCup: "Stanley Cup",
        afcEast: "AFC Este",
        afcNorth: "AFC Norte",
        nfcNorth: "NFC Norte",
        nfcWest: "NFC Oeste",
        nlCentral: "NL Central",
        nlWest: "NL Oeste",
        premierLeague: "Premier League",
        divisionWinner: "Ganador de división",
      },
    },
    advancedTools: {
      marketAgainst: "{{market}} en contra",
      vsOpponent: "vs {{opponent}}",
    },
    sponsoredBy: "Patrocinado por {{operator}}",
  },
};
